// Permissions des utilisateurs (réglées dans Administrateur › Utilisateurs).
// Le serveur envoie user.permissions = droits réellement accordés (tous pour un admin).
export const peut = (user, cle) => !!user && (user.is_admin || !!user.permissions?.[cle]);

// Pages dans l'ordre où l'on cherche la première accessible.
const PAGES = [
  ["/", "onglet_dashboard"],
  ["/carte", "onglet_carte"],
  ["/carte/tournees", "carte_tournees_voir"],
  ["/scans", "scan_remise"],
  ["/scans/reception", "scan_reception"],
  ["/scans/config", "scan_config"],
  ["/colis", "colis_colis"],
  ["/colis/depot", "colis_depot"],
  ["/colis/cage", "colis_cage"],
  ["/colis/listes", "colis_listes"],
  ["/chauffeurs", "onglet_chauffeurs"],
  ["/outils/famis", "onglet_famis"],
  ["/outils/registre", "onglet_registre"],
  ["/factures", "onglet_factures"],
];

export function premierePage(user, prefixe = "") {
  const p = PAGES.find(([to, cle]) => to.startsWith(prefixe) && peut(user, cle));
  return p ? p[0] : null;
}
